import React from 'react'
import { Alert } from 'antd'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  render () {
    if (this.state.hasError) {
      return (
        <Alert
          message='Error'
          description={this.props.message || 'Something went wrong while rendering this page.'}
          type='error'
          showIcon
        />
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
